module.exports = __webpack_public_path__ + "img/home-serve2.beebc36d.png";